import { useMsal } from "@azure/msal-react";
import axios from 'axios';
import { useContext, useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { HiPencilSquare } from "react-icons/hi2";
import Select from "react-select";
import ReactTable from "react-table";
import "react-table/react-table.css";
import { toast } from "react-toastify";
import { AuthContext } from "../../../../../AuthContext";
import { DATABOOK_API } from "../../../../../constants/serverConfig";
import { protectedResources } from "../../../../../msalConfig"
import Search from "../../../../Search";
import Modalbox from "../../../../Datasets/AllDataSets/Individual/IndividualDataTabs/ColumnsTab/Modalbox";
import CountDisOverview from "../../../../Datasets/AllDataSets/Individual/IndividualDataTabs/ColumnsTab/SubComponents/CountDisOverview";
import ProfilingMetricsSubOverview from "../../../../Datasets/AllDataSets/Individual/IndividualDataTabs/ColumnsTab/SubComponents/ProfilingMetricsSubOverview";
import ValidationOverview from "../../../../Datasets/AllDataSets/Individual/IndividualDataTabs/ColumnsTab/SubComponents/ValidationOverview";

const MetricColumnsTable = (props) => {
  const columndata = props.data;
  const [filterdata, setFilterData] = useState([...props.data]);
  const [show, setShow] = useState(false);
  const handleShow = (flag) => setShow(flag);
  const handleClose = (flag) => setShow(flag);
  const [selectedrow, setSelectedRow] = useState({});
  // const [classification, setClassification] = useState([]);
  // const [sensitivity, setSensitivity] = useState([]);
  const [selectedClassification, setSelectedClassification] = useState("");
  const [selectedSensitivity, setSelectedSensitivity] = useState([]);
  const { getToken, token, error } = useContext(AuthContext);
  // ---------------------------react select----------------
  const [rsClassificationList, seRSClassificationList] = useState([]);
  const [rsSelectedClassification, seSelectedRSClassification] = useState("");
  const [rsSensitivityList, seRSSensitivityList] = useState([]);
  const [rsSelectedSensitivity, seSelectedRSSensitivity] = useState([]);
  const [selectedtags, setSelectedTags] = useState([]);
  const { instance } = useMsal();
  const account = instance.getActiveAccount();
  const request = {
    scopes: protectedResources.databook.scopes,
    account: account,
  };

  var columnfieldvalue = "";

  const colourStyles = {
    option: (styles) => {
      return {
        ...styles,
        backgroundColor: "#D3D3D3",
        color: "black",
      };
    },
  };

  const searchcolumns = (e) => {
    const filtered = props.data.filter((o) =>
      ["name"].some((k) =>
        String(o[k]).toLowerCase().includes(e.target.value.toLowerCase())
      )
    );
    setFilterData(filtered);
  };
  useEffect(() => {
    callapiwithtoken(getSecurityClassification);
  }, [])

  const getClassificationSensitivityToken = (token, classificationId) => {
    axios.get(`${DATABOOK_API}/glossary-classification/terms/${classificationId}/terms`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    })
      .then((res) => {
        let topleveldata = res?.data?.glossaryTerms.map((item) => {
          return {
            id: 1,
            pId: 0,
            value: '1',
            val: item.classificationName,
            title: item.termName,
            termName: item.termName,
            fqn: item.fqn,
            description: item?.description,
            isLeaf: false
          };
        })
        seRSSensitivityList(res.data?.glossaryTerms.map((item) => ({ value: item.fqn, label: item.termName })));
        // setSensitivity(topleveldata)
      })
  }

  const openModel = async (rowdata) => {
    if (rowdata?.original?.securityClassification) {
      let defaultClassi = rsClassificationList.find((item) => item.value === rowdata?.original?.securityClassification)
      seSelectedRSClassification(defaultClassi);
    }
    if (rowdata?.original?.sensitivity && rowdata?.original?.sensitivity?.length > 0) {
      await axios.get(`${DATABOOK_API}/glossary-classification/terms/${rowdata?.original?.securityClassification}/terms`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
        .then((res) => {
          let selectSensitivity = res?.data?.glossaryTerms.find(x => x.fqn === rowdata?.original?.sensitivity);
          seRSSensitivityList(res?.data?.glossaryTerms.map((item) => ({ value: item.fqn, label: item.termName })))
          const result = res?.data?.glossaryTerms.filter(c => rowdata?.original?.sensitivity.some(s => s === c.fqn));
          seSelectedRSSensitivity(result.map((item) => ({ value: item.fqn, label: item.termName })))

        })
      setSelectedSensitivity(rowdata.original.sensitivity);
    } else {
      // Handle undefined sensitivity
      seRSSensitivityList([]);
      seSelectedRSSensitivity([]);
      setSelectedSensitivity([]);
    }
    if (rowdata?.original?.tags) {
      let defaultagselected = rowdata?.original?.tags.map((tag) => ({ value: tag.fqn, label: tag.tagName }));
      setSelectedTags(defaultagselected);
    } else {
      setSelectedTags([]);
    }
    handleShow(true);
    setSelectedRow({ columnid: rowdata.column.id, rowdata: rowdata.original })
  }
  const closeModel = () => {
    seSelectedRSClassification("")
    seSelectedRSSensitivity([])
    handleClose(false);
  }
  const getSensitivityForClassification = async (classificationId) => {
    (async () => await getToken())();
    if (token) {
      await getClassificationSensitivityToken(token, classificationId);
    }
    if (error) {
      try {
        const rtoken = (await instance.acquireTokenRedirect(request))
          .accessToken;
        await getClassificationSensitivityToken(rtoken, classificationId);
      } catch (error) {
        console.log(error);
      }
    }
  }

  const modalHandler = (data, e, name) => {
    switch (name) {
      case "description":
        columnfieldvalue = e?.target?.value.trim();
        break;
      case "securityClassification":
        columnfieldvalue = data.filter(function (item) {
          return e?.indexOf(item.id) !== -1;
        }).map((item) => item.fqn)[0]?.trim();
        setSelectedClassification(columnfieldvalue);
        getSensitivityForClassification(columnfieldvalue);
        setSelectedSensitivity([])
        break;
      case "sensitivity":
        columnfieldvalue = data.filter(function (item) {
          return e?.indexOf(item.id) !== -1;
        }).map((item) => item.fqn);
        setSelectedSensitivity(columnfieldvalue);
        break;
      default:
        columnfieldvalue = ""
    }

  }
  const getSecurityClassification = async (token) => {
    const classificationresult = await axios.get(`${DATABOOK_API}/glossary-classification`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    });

    axios.get(`${DATABOOK_API}/glossary-classification/terms/classification/${classificationresult?.data?.glossaryClassifications[0]?.classificationName}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    })
      .then((res) => {
        let topleveldata = res.data?.glossaryTerms.map((item) => {
          return {
            id: 1,
            pId: 0,
            value: '1',
            val: item.classificationName,
            title: item.termName,
            termName: item.termName,
            fqn: item.fqn,
            description: item?.description,
            isLeaf: true
          };
        })
        seRSClassificationList(res.data?.glossaryTerms.map((item) => ({ value: item.fqn, label: item.termName })));
        // setClassification(topleveldata)
      })
  }

  const callapiwithtoken = async (callback) => {
    (async () => await getToken())();
    if (token) {
      await callback(token);
    }
    if (error) {
      try {
        const rtoken = (await instance.acquireTokenRedirect(request))
          .accessToken;
        await callback(rtoken);
      } catch (error) {
        console.log(error);
      }
    }
  }
  const handleDataTypeForEmptyValue = (columnname) => {
    /**
     * Common function will handle the default value for all field in table
     */

    switch (columnname) {

      case "sensitivity":
        if (columnfieldvalue === "") columnfieldvalue = []

    }

  }

  const validateFields = () => {
    return rsSelectedClassification?.value?.indexOf("confidential") > -1;

  }
  const columnFielsdSave = (token) => {
    if (selectedrow?.columnid !== "description") {
      if (validateFields() &&
        rsSelectedSensitivity?.length === 0) {
        toast.info("Security classificaton or sensitivity cannot be blank. ", {
          position: "top-right",
          autoClose: 6000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return false;
      }
    }


    // handleDataTypeForEmptyValue(selectedrow?.columnid);
    const inprogresstoast = toast.info("Updating description. Please wait...");
    let requestbody = "";
    if (selectedrow?.columnid === "description") {
      requestbody = {
        id: selectedrow?.rowdata.dataset_id,
        columns: [
          {
            name: selectedrow?.rowdata.name,
            description: columnfieldvalue,
          },
        ],
      }
    } else if (selectedrow?.columnid === "tags") {
      requestbody = {
        id: selectedrow?.rowdata.dataset_id,
        columns: [
          {
            name: selectedrow?.rowdata.name,
            tags: selectedtags.map((tag) => ({ fqn: tag.value, tagName: tag.label }))
          }
        ],
      }
    } else {
      requestbody = {
        id: selectedrow?.rowdata.dataset_id,
        columns: [
          {
            name: selectedrow?.rowdata.name,
            securityClassification: rsSelectedClassification?.value === undefined ? "" : rsSelectedClassification?.value,
            sensitivity: rsSelectedSensitivity?.map((item) => item.value)
          },
        ],
      }
    }

    axios.put(`${DATABOOK_API}/datasets/dataset-columns`, requestbody, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    })
      .then((res) => {
        props.getallcolumndata(token);
        toast.update(inprogresstoast, {
          render: "Column field updated successfully.",
          type: toast.TYPE.SUCCESS,
          autoClose: 6000,
          closeButton: true,
          isLoading: false
        });
        closeModel();
      })
      .catch((error) => {
        if (error.response.status == 401) {
          toast.update(inprogresstoast, {
            render: error.response.data,
            type: toast.TYPE.ERROR,
            autoClose: 6000,
            closeButton: true,
            isLoading: false
          });
          closeModel();
        } else {
          toast.update(inprogresstoast, {
            render: "Some went wrong while updating columns field.",
            type: toast.TYPE.ERROR,
            autoClose: 6000,
            closeButton: true,
            isLoading: false
          });
        }

      });
    closeModel();
  }

  const profilerHandler = (profile, columnName) => {
    let updatefilterdata = [...filterdata];
    let datasetIndex = updatefilterdata.findIndex(obj => obj.name == columnName);
    updatefilterdata[datasetIndex].profilersdropdefaultValue = { label: profile.value, value: profile.value };
    setFilterData(updatefilterdata);
  }




  const rsclassificationHandler = (classification) => {
    seSelectedRSClassification(classification);
    if (classification === null) {
      seSelectedRSClassification("");
    }
    if (classification) {
      getSensitivityForClassification(classification.value)
    }
    seSelectedRSSensitivity([]);
  }

  const rsSensitivityHandler = (sensitivity) => {
    seSelectedRSSensitivity(sensitivity);
    let newtag
  }
  const handletagChange = (tags) => {
    // let newtag = tags.map((tag) => ({ fqn: tag.value, tagName: tag.label }))
    // console.log("newtag :: ", newtag)
    setSelectedTags(tags);

  }

  return (
    <div style={{ border: "0px solid green" }} >
      {filterdata.length > 0 ? (
        <>
          <Row>
            <Search
              divstyle="d-flex justify-content-end mb-2 bg-white"
              placeHolder="Search by Name"
              iconSize={20}
              searchFunc={searchcolumns}
              innerwrapper="custom-border"
            />
          </Row>
          <ReactTable
            data={filterdata}
            sortable={true}
            collapseOnDataChange={false}
            size="sm"
            showPagination={true}
            getTrProps={(state, rowInfo, column) => {
              if (rowInfo === undefined) {
                return {};
              }
              return {
                "data-qnt": (rowInfo.original.profilersdrop || rowInfo.original.validationdrop) ? 1 : 0,
              };
            }}

            columns={[
              {
                Header: () => <div className="column__table__header">Name</div>,
                accessor: "name",
                width: 200,

              },
              {
                Header: () => (
                  <div className="column__table__header">Data Type</div>
                ),
                accessor: "col_datatype",
              },
              {
                Header: () => <div className="column__table__header">Type</div>,
                accessor: "type",
                Cell: (cellInfo) => <span>{cellInfo.value || "-"}</span>, // Handle null values
              },
              {
                Header: () => <div className="column__table__header">Title</div>,
                accessor: "title",
                Cell: (cellInfo) => <span>{cellInfo.value || ""}</span>, // Handle null values
                width: 150,
              },
              {
                Header: () => <div className="column__table__header">Expression</div>,
                accessor: "expression",
                Cell: (cellInfo) => <span>{cellInfo.value || "-"}</span>, // Handle null values
                width: 300,
              },
              {
                Header: () => (
                  <div className="column__table__header">Description</div>
                ),
                accessor: "description",
                width: 400,
                Cell: cellInfo => <div className="cell-wrapper" >
                  <div data-bs-backdrop="false" data-toggle="modal" >
                    {cellInfo.original.description}
                    <div className="edit-desc" onClick={() => openModel(cellInfo)}>
                      <HiPencilSquare size={15} />
                    </div>
                  </div>
                </div>
              },
              // {
              //   Header: () => <div className="column__table__header">Tags</div>,
              //   accessor: "tags",
              //   Cell: cellInfo => (<div className="cell-wrapper">
              //     {cellInfo?.original?.tags.map((item) => <span className=" custom-span-content">{item?.tagName}</span>)}

              //     {/* {props.editaccessflag ? ( */}
              //     <div className="edit-desc " onClick={() => openModel(cellInfo)} >
              //       <HiPencilSquare size={15} />
              //     </div>
              //     {/* ) : ""} */}
              //   </div>),
              //   width: 200
              // },
              {
                Header: () => <div className="column__table__header">Tags</div>,
                accessor: "tags",
                Cell: (cellInfo) => (
                  <div className="cell-wrapper">
                    {cellInfo?.original?.tags && cellInfo.original.tags.length > 0 ? (
                      cellInfo.original.tags.map((item) => (
                        <span className="custom-span-content">{item?.tagName}</span>
                      ))
                    ) : (
                      <span>No tags available.</span>
                    )}
                    <div className="edit-desc " onClick={() => openModel(cellInfo)} >
                      <HiPencilSquare size={15} />
                    </div>
                  </div>
                ),
                width: 200,
              },
              {
                Header: () => (
                  <div className="column__table__header">Security Classification</div>
                ),
                accessor: "securityClassification",
                Cell: cellInfo => (<div className="cell-wrapper" >
                  <div data-bs-backdrop="false" data-toggle="modal" >
                    {cellInfo.original?.securityClassification?.replace("securityclassification.", "") ? <span className=" custom-span-content"> {cellInfo.original?.securityClassification?.replace("securityclassification.", "")}</span> : ""}

                    {/* {props.editaccessflag ? ( */}
                    <div className="edit-desc " onClick={() => openModel(cellInfo)} >
                      <HiPencilSquare size={15} />
                    </div>
                    {/* ) : ""} */}

                  </div>
                </div>),
                width: 300
              },
              // {
              //   Header: () => (
              //     <div className="column__table__header">Sensitivity</div>
              //   ),
              //   accessor: "sensitivity",
              //   Cell: cellInfo => (<div className="cell-wrapper" >
              //     <div data-bs-backdrop="false" data-toggle="modal" >
              //       <div className="d-inline-block sensitivity-content">
              //         {cellInfo.original?.sensitivity?.map((item, index) => <span key={index} className=" custom-span-content">{item?.replace("securityclassification." + cellInfo.original?.securityClassification?.replace("securityclassification.", "") + ".", "")}</span>)}
              //       </div>
              //       {/* {props.editaccessflag ? ( */}
              //       <div className="edit-desc " onClick={() => openModel(cellInfo)} >
              //         <HiPencilSquare size={15} />
              //       </div>
              //       {/* ) : ""} */}

              //     </div>
              //   </div>),
              //   width: 350
              // },
              {
                Header: () => (
                  <div className="column__table__header">Sensitivity</div>
                ),
                accessor: "sensitivity",
                Cell: (cellInfo) => (
                  <div className="cell-wrapper">
                    <div data-bs-backdrop="false" data-toggle="modal">
                      <div className="d-inline-block sensitivity-content">
                        {cellInfo.original?.sensitivity && cellInfo.original.sensitivity.length > 0 ? (
                          cellInfo.original.sensitivity.map((item, index) => (
                            <span key={index} className="custom-span-content">
                              {item?.replace(
                                "securityclassification." +
                                cellInfo.original?.securityClassification?.replace(
                                  "securityclassification.",
                                  ""
                                ) +
                                ".",
                                ""
                              )}
                            </span>
                          ))
                        ) : (
                          <span>No sensitivity data.</span>
                        )}
                      </div>
                      {/* ... */}
                    </div>
                  </div>
                ),
                width: 350,
              },

              {
                Header: () => (
                  <div className="column__table__header">Profilers</div>
                ),
                Cell: (row) => {
                  let maindata = row.original;
                  return maindata.analyzers.length === 0 ? (
                    ""
                  ) : (
                    <Select
                      options={row.original.profilersdrop}
                      defaultValue={row.original.profilersdropdefaultValue}
                      menuPortalTarget={document.body}
                      styles={colourStyles}
                      onChange={(e) => profilerHandler(e, row.original.name)}
                    />
                  );
                },
                width: 180
              },
              {
                Header: () => (
                  <div className="column__table__header">Validation</div>
                ),

                Cell: (row) => {
                  let maindata = row.original;
                  return maindata.metric.length === 0 ? (
                    ""
                  ) : (
                    <Select
                      options={row.original.validationdrop}
                      defaultValue={row.original.validationdrop}
                      menuPortalTarget={document.body}
                      styles={colourStyles}
                    />
                  );
                },
                width: 180
              },
            ]}
            // columns={[
            //     {
            //       Header: () => <div className="column__table__header">Name</div>,
            //       accessor: "name",
            //       width: 200,
            //     },
            //     {
            //       Header: () => <div className="column__table__header">Data Type</div>,
            //       accessor: "col_datatype",
            //     },
            //     {
            //       Header: () => <div className="column__table__header">Type</div>,
            //       accessor: "type",
            //       Cell: (cellInfo) => <span>{cellInfo.value || "-"}</span>, // Handle null values
            //     },
            //     {
            //       Header: () => <div className="column__table__header">Title</div>,
            //       accessor: "title",
            //       Cell: (cellInfo) => <span>{cellInfo.value || "-"}</span>, // Handle null values
            //       width: 150,
            //     },
            //     {
            //       Header: () => <div className="column__table__header">Expression</div>,
            //       accessor: "expression",
            //       Cell: (cellInfo) => <span>{cellInfo.value || "-"}</span>, // Handle null values
            //       width: 300,
            //     },
            //     // ... rest of your columns

            //   ]}



            defaultPageSize={10}
            SubComponent={(row) => {
              let objectid = row.original.dataset_id + "." + row.original.name;
              return (
                <Container className="py-3">
                  <Row>
                    <Col md={4}>
                      {row.original.profilersdrop ? (
                        <>
                          <div className="sub__tableheader">
                            <h2>Count Distinct</h2>
                          </div>
                          <CountDisOverview
                            graphdata={objectid}
                            profile={row.original.profilersdropdefaultValue}
                          />
                        </>
                      ) : ""}

                    </Col>
                    <Col md={4}>
                      {row.original.profilersdrop ? (
                        <>
                          <div className="sub__tableheader">
                            <h2>Profiling Metrics</h2>
                          </div>
                          <ProfilingMetricsSubOverview
                            pfdata={objectid}
                            profile={row.original.profilersdropdefaultValue}
                          />
                        </>
                      ) : ""}

                    </Col>
                    <Col md={4}>
                      {row.original.validationdrop ? (
                        <>
                          <div className="sub__tableheader">
                            <h2>Validation Metrics</h2>
                          </div>
                          <ValidationOverview
                            vdata={objectid}
                            profile={row.original.profilersdropdefaultValue}
                          />
                        </>
                      ) : ""}


                    </Col>
                  </Row>
                </Container>
              );
            }}
          />
        </>
      ) : (
        <Row>
          <div className="text-center p-5"><span>No Data found.</span></div>
        </Row>
      )}

      {show ? (< Modalbox
        show={show}
        setShow={handleClose}
        row={selectedrow}
        descValue={selectedrow.rowdata?.description}
        closeModel={closeModel}
        modalHandler={modalHandler}
        updateColumnsFields={() => callapiwithtoken(columnFielsdSave)}
        // classification={classification}
        // sensitivity={sensitivity}
        // selectedClassification={selectedClassification}
        // selectedSensitivity={selectedSensitivity}
        // -----------------------------------------------
        rsClassificationList={rsClassificationList}
        rsclassificationHandler={rsclassificationHandler}
        rsSelectedClassification={rsSelectedClassification}
        rsSensitivityList={rsSensitivityList}
        rsSensitivityHandler={rsSensitivityHandler}
        rsSelectedSensitivity={rsSelectedSensitivity}
        datasetstage={props.datasetstage}
        handletagChange={handletagChange}
        selectedtags={selectedtags}
      />) : ""}


    </div >
  );
};

export default MetricColumnsTable;
